/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Heading, HFlow, Modal, ModalBody, ModalFooter, VFlow } from 'bold-ui'
import { FormProps } from 'components/form'
import { FormApi } from 'final-form'

import TecidosMolesForm, { TecidosMolesFormModel } from './TecidosMolesForm'
import TecidosMolesFormFields from './TecidosMolesFormFields'

export interface EditarTecidosMolesFormModalProps extends Omit<FormProps<TecidosMolesFormModel>, 'render'> {
  open?: boolean
  cidadaoDataNascimento: LocalDate
  onClose(): void
}

export default function EditarTecidosMolesFormModal(props: EditarTecidosMolesFormModalProps) {
  const { open, cidadaoDataNascimento, onSubmit, onClose, initialValues, ...formProps } = props

  const handleSubmit = (values: TecidosMolesFormModel, form: FormApi<TecidosMolesFormModel>) => {
    onSubmit(values, form)
    onClose()
  }

  return (
    <TecidosMolesForm
      onSubmit={handleSubmit}
      initialValues={initialValues}
      render={(renderProps) => (
        <Modal
          open={open}
          onClose={onClose}
          style={css`
            width: 45rem;
          `}
        >
          <ModalBody>
            <VFlow>
              <Heading level={1}>Editar evolução</Heading>

              <TecidosMolesFormFields
                cidadaoDataNascimento={cidadaoDataNascimento}
                parteBucalSelecionada={renderProps.values?.local?.value}
                hasProcedimentos={renderProps.values?.procedimentos?.length > 0}
                disableProblemas={!renderProps.values?.local}
                preExpanded={!!initialValues?.caracteristicasLesao}
              />
            </VFlow>
          </ModalBody>

          <ModalFooter>
            <HFlow justifyContent='flex-end'>
              <Button kind='normal' onClick={onClose}>
                Cancelar
              </Button>
              <Button kind='primary' onClick={renderProps.handleSubmit}>
                Salvar
              </Button>
            </HFlow>
          </ModalFooter>
        </Modal>
      )}
      {...formProps}
    />
  )
}
